// extracted by css-extract-rspack-plugin
export default {"actionsCell":"GivingActionsTableRow_actionsCell__R2k3c","description":"GivingActionsTableRow_description__AN4Un"};